export enum DurationFormat {
  SHORT = 'short',
  LONG = 'long',
}
